export class ProjectType {
    projectTypeId?: string;
    name: string;
    description: string;
    isSelected: boolean;
    schemaRevision?: SchemaRevision;
    schemaVersions?: SchemaVersion[];
    editedDate?: string;
    statuses: ProjectTypeStatus[];
}

export class SchemaRevision {
    schema: string;
}

export class SchemaVersion {
    schemaVersionId?: string;
    version: number;
    changeReason?: string;
    schema: string;
    jsonEditorOptions?: any;
    editedDate?: string;
}

export class ProjectTypeStatus {
    projectTypeStatusID: string;
    name: string;
    colour: string;
}

export class DeleteProjectType {
    projectTypeId: string;
    active: boolean;
}

export class ProjectDefaultStatusType {
    name: string;
    index?: number;
    statusTypeId?: string;
    colour?: string;
}
